import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Typography } from '@mui/material';

import { selectLoader } from 'base/auth/selectors';
import { selectEnterprise } from 'base/core/selectors';
import ResetTempPasswordFormValidation from
  'pages/reset-temp-password/validation/reset-password-form-validation';
import useAuthentication from 'base/auth/hooks/use-authentication';
import { GuestLayout } from 'components/templates';
import { authSliceActions } from 'base/auth/slice';
import ResetTempPasswordFormView from '../reset-temp--password-form';

const ResetTempPasswordView = () => {
  useAuthentication();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get('email');
  const tempPassword = urlParams.get('tempPassword');

  const methods = useForm({
    defaultValues: {
      password: tempPassword,
      name: email?.replace(' ', '+'),
      newPassword: '',
      confirmPassword: '',
    },
    resolver: yupResolver(ResetTempPasswordFormValidation),
    shouldFocusError: true,
  });
  const dispatch = useDispatch();
  const loading = useSelector(selectLoader);
  const enterprice = useSelector(selectEnterprise);

  const { isAuthenticated } = useAuthentication();

  useEffect(() => {
    const authenticated = isAuthenticated();
    if (authenticated) {
      navigate('/profile/update?newProfile=true');
    } if (!email || !tempPassword) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate, email, tempPassword]);

  const handleSubmitFrom: SubmitHandler<any> = useCallback(
    (data) => {
      dispatch(authSliceActions.resetTempPassword(data));
    },
    [dispatch],
  );

  const formWrapperStyles = { width: { xs: '100%', md: '600px' } };

  return (
    <GuestLayout loading={loading}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className="text-center py-4"
      >
        <Grid item sx={formWrapperStyles}>
          <Typography variant="h2" sx={{ mb: 6 }}>{ enterprice.name ? `Welcome to ${enterprice.name}` : 'Welcome to Slocoach'}</Typography>
          <Typography variant="body1" sx={{ display: 'inline-block', mb: 5 }}>
            Almost there! You
            &nbsp;
            <b>
              (
              {email}
              )
            </b>
            &nbsp;
            have been invited to setup your expert account on
            &nbsp;
            <b>
              { enterprice.name ? enterprice.name : 'Slocoach'}
              .
            </b>
            &nbsp;
            Let&apos;s get your password set up first and then move on to setting
            up your expert profile!
          </Typography>
          <FormProvider {...methods}>
            <ResetTempPasswordFormView onSubmit={handleSubmitFrom} />
          </FormProvider>
        </Grid>
      </Grid>
    </GuestLayout>
  );
};

export default ResetTempPasswordView;
